import React, { Component, useState } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";

import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";

import { api } from "../../Services/index";
import { axiosClient, config } from "./../../Services/Config";

import { Document, Page } from "react-pdf";

// import samplePDF from '../../dist/pdfsample/sample2.pdf';
// import samplePDF from 'http://africau.edu/images/default/sample.pdf';

import SinglePagePDFViewer from "./single-page";
import AllPagesPDFViewer from "./all-pages";
import IdleTimer from "../../common/IdleTimer";

const samplePdfFiles = [
  {
    dcgid: 1,
    fileurl:
      "https://bg1mkm3fnf.execute-api.us-east-1.amazonaws.com/v1/dcgforms/print?dcgid=1803&type=stream",
  },
  {
    dcgid: 2,
    fileurl:
      "https://sonc02ak7f.execute-api.us-east-1.amazonaws.com/v1/dcgforms/print?dcgid=1779&storeid=89110&salesrepid=1156112&salesrepname=dcg_test_assoc&type=download",
  },
  {
    dcgid: 3,
    fileurl:
      "https://bg1mkm3fnf.execute-api.us-east-1.amazonaws.com/v1/dcgforms/print?dcgid=1285&type=stream",
  },
];

const loaderStyle = {
  color: "#f3f3f3",
};

const objStyle = {
  width: "95%",
  height: "500px",
};

class DcgViewerPdf extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 5,
      dailySummaryData: [],
      spinnerColor: "#000000",
      spinnerLoading: false,
      userLoggedIn: false,
      loginname: null,
      userloginid: null,
      pdfDCGIds: [],

      samplePdfFilesList: [],
      currentPdfFileUrl:
        "https://bg1mkm3fnf.execute-api.us-east-1.amazonaws.com/v1/dcgforms/print?dcgid=1803&type=stream",
      currentPdfFileIndex: 0,
      btnPrevPdfDisabled: true,
      btnNextPdfDisabled: true,
      showPdfPreview: false,
    };

    this.clickPrevPdf = this.clickPrevPdf.bind(this);
    this.clickNextPdf = this.clickNextPdf.bind(this);
  }

  componentDidMount() {
    // this.setUserInfo();

    const tmpPdfUrls = [];
    this.setState(
      { pdfDCGIds: this.props.history.location.state.pdfDCGIds },
      () => {
        for (
          let i = 0;
          i <= this.props.history.location.state.pdfDCGIds.length - 1;
          i++
        ) {
          tmpPdfUrls.push({
            dcgid: this.state.pdfDCGIds[i],
            fileurl:
              "https://bg1mkm3fnf.execute-api.us-east-1.amazonaws.com/v1/dcgforms/print?dcgid=" +
              this.state.pdfDCGIds[i] +
              "&type=stream",
          });
        }

        this.setState(
          {
            samplePdfFilesList: tmpPdfUrls,
            currentPdfFileUrl: tmpPdfUrls[0].fileurl,
            currentPdfFileIndex: 0,
            btnPrevPdfDisabled: true,
            btnNextPdfDisabled: tmpPdfUrls.length <= 1,
            showPdfPreview: true,
          },
          () => {
            console.log("set state");
            // console.log(this.state)
          },
        );
      },
    );
  }

  setUserInfo = () => {
    var userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userinfo) {
      this.setState({
        loginname: userinfo.roleinfo.loginname,
        userloginid: userinfo.roleinfo.userloginid,
        userLoggedIn: true,
      });
    } else {
      this.props.history.push("/login");
      // return;
    }
  };

  tabchangeevent = (e) => {
    this.setState({ tab: e });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  clickPrevPdf = () => {
    let index = this.state.currentPdfFileIndex - 1;
    let disabledPrev = false;
    if (index <= 0) {
      index = 0;
      disabledPrev = true;
    }

    this.setState({
      currentPdfFileIndex: index,
      btnPrevPdfDisabled: disabledPrev,
      btnNextPdfDisabled: false,
      showPdfPreview: true,
    });
  };

  clickNextPdf = () => {
    let index = this.state.currentPdfFileIndex + 1;
    let disabledNext = false;

    if (index === this.state.samplePdfFilesList.length - 1) {
      index = this.state.samplePdfFilesList.length - 1;
      disabledNext = true;
    }

    this.setState({
      currentPdfFileIndex: index,
      btnPrevPdfDisabled: false,
      btnNextPdfDisabled: disabledNext,
      showPdfPreview: true,
    });

    console.log(this.state);
  };

  render() {
    return (
      <div className="wrapper">
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          <Header />
          <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
          <IdleTimer></IdleTimer>
          <div className="content-wrapper pb-4">
            <section class="content">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <h5>DCG Viewer</h5>
                    <hr />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <button
                      onClick={this.clickPrevPdf}
                      disabled={this.state.btnPrevPdfDisabled}
                      class="btn btn-primary"
                    >
                      &lt;&lt; Prev
                    </button>
                  </div>
                  <div class="col-md-4">
                    <button onClick={this.goBack} class="btn btn-primary">
                      Go Back
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      onClick={this.clickNextPdf}
                      disabled={this.state.btnNextPdfDisabled}
                      class="btn btn-primary"
                    >
                      Next &gt;&gt;
                    </button>
                  </div>
                  <div class="col-md-2"></div>
                </div>

                {/* <Document file={samplePDF} options={{workerSrc: "pdf.worker.js"}}>
                            <Page pageNumber={1} />
                        </Document> */}

                {/* <SinglePagePDFViewer pdf={samplePDF} /> */}

                {/* <AllPagesPDFViewer pdf={samplePDF} /> */}

                {/* <div>
                            <AllPagesPDFViewer pdf={samplePdfFiles[this.state.currentPdfFileIndex].fileurl} />
                        </div> */}

                {this.state.showPdfPreview === true && (
                  <div class="col-md-12">
                    <AllPagesPDFViewer
                      pdf={
                        this.state.samplePdfFilesList[
                          this.state.currentPdfFileIndex
                        ].fileurl
                      }
                    />
                    {/* <AllPagesPDFViewer pdf={samplePdfFiles[this.state.currentPdfFileIndex].fileurl} /> */}
                  </div>
                )}

                {/* <object data={samplePDF} type="application/pdf">
                            <embed src={samplePDF} type="application/pdf" />
                        </object> */}

                {/* {(this.state.showPdfPreview === true) && (
                        <div class="col-md-12" >
                            <object data={this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl} type="application/pdf" style={objStyle}>
                                <embed src={this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl} type="application/pdf" />
                            </object>
                        </div>
                    )} */}
              </div>
            </section>
          </div>
        </LoadingOverlay>

        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(DcgViewerPdf);
